import { NgStyle } from '@angular/common';
import { Component, Input, HostBinding, OnInit, OnDestroy, OnChanges, Output, EventEmitter, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'mizvid-videoShow',
  templateUrl: 'videoShow.component.html',
  styleUrls: [
    'videoShow.component.scss',
  ]
}) export class videoShowComponent implements OnInit, OnChanges, OnDestroy {
  @Input('shenase') shenase: string;
  @HostBinding('style.display') display: string;

  @Output() close_req: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('click') coverClick() {
    console.log('بر کاور کلیک شد');
    this.close_req.emit(null);
  }
  constructor(private sanitizer: DomSanitizer,) { }

  getVideoUrl(shenase: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl('https://www.aparat.com/video/video/embed/videohash/' + shenase + '/vt/frame');
  }


  @Output('videoInit') videoInit_Output: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit() {
    console.log('کامپوننت نمایش ویدئو ایجاد شد');
    this.videoInit_Output.emit(
      { //... اطلاعات شکل‌گیری کامپوننت به عنوان خروجی.
        //یعنی از خوددش به بیرونی‌ها خبر می‌دهد
        shenase: this.shenase,
      }
    );
  }
  ngOnChanges() {
    console.log('تغییری رخ داد!');
  }
  ngOnDestroy() {
    console.log('×××کامپوننت نمایش ویدئو از بین رفت');
  }
}
